import { render, staticRenderFns } from "./addPurchase.vue?vue&type=template&id=7a23b440&scoped=true&"
import script from "./addPurchase.vue?vue&type=script&lang=js&"
export * from "./addPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a23b440",
  null
  
)

export default component.exports